import React from "react";
import { Link } from "react-router-dom";
import { 
  FaBriefcase, 
  FaBuilding, 
  FaTrophy, 
  FaUsers, 
  FaChartLine,
  FaCheckCircle,
  FaArrowRight,
  FaRupeeSign,
  FaMapMarkerAlt,
  FaGlobe,
  FaHandshake,
  FaStar
} from "react-icons/fa";
import { MdWork, MdVerified } from "react-icons/md";

const PlacementPage = () => {
  const stats = [
    { label: "Placement Rate", value: "98%", icon: <FaChartLine />, color: "blue" },
    { label: "Partner Companies", value: "150+", icon: <FaBuilding />, color: "green" },
    { label: "Students Placed", value: "1200+", icon: <FaUsers />, color: "purple" },
    { label: "Highest Package", value: "8.5 LPA", icon: <FaRupeeSign />, color: "orange" }
  ];

  const recruiters = [
    { name: "Apollo Hospitals", logo: "/apollo-logo.png", location: "Pan India" },
    { name: "Max Healthcare", logo: "/max-logo.png", location: "Delhi NCR" },
    { name: "Fortis Healthcare", logo: "/fortis-logo.png", location: "Pan India" },
    { name: "Medanta Hospital", logo: "/medanta-logo.png", location: "Gurugram" },
    { name: "Cipla", logo: "/cipla-logo.png", location: "Mumbai" },
    { name: "Sun Pharma", logo: "/sun-logo.png", location: "Pan India" },
    { name: "Lupin", logo: "/lupin-logo.png", location: "Mumbai" },
    { name: "Dr. Reddy's", logo: "/reddy-logo.png", location: "Hyderabad" },
    { name: "AIIMS", logo: "/aiims-logo.png", location: "Delhi" },
    { name: "Safdarjung Hospital", logo: "/safdarjung-logo.png", location: "Delhi" },
    { name: "KGMU", logo: "/kgmu-logo.png", location: "Lucknow" },
    { name: "SGPGI", logo: "/sgpgi-logo.png", location: "Lucknow" }
  ];

  const placementProcess = [
    {
      step: "01",
      title: "Registration",
      description: "Students register for placement drive with their preferences"
    },
    {
      step: "02",
      title: "Pre-Placement Talk",
      description: "Companies conduct sessions about their organization"
    },
    {
      step: "03",
      title: "Aptitude Test",
      description: "Online/written test to assess logical and analytical skills"
    },
    {
      step: "04",
      title: "Technical Interview",
      description: "Subject knowledge and practical skills assessment"
    },
    {
      step: "05",
      title: "HR Interview",
      description: "Final round for personality and communication check"
    },
    {
      step: "06",
      title: "Offer Letter",
      description: "Selected candidates receive offer letters"
    }
  ];

  const topRecruiters = [
    { name: "Apollo Hospitals", package: "6-8 LPA", positions: "Staff Nurse" },
    { name: "Max Healthcare", package: "5-7 LPA", positions: "Nursing Officer" },
    { name: "Cipla", package: "4-6 LPA", positions: "Pharmacist" },
    { name: "AIIMS", package: "7-9 LPA", positions: "Senior Nurse" }
  ];

  const alumni = [
    {
      name: "Priya Singh",
      batch: "2022",
      company: "Apollo Hospitals",
      position: "Senior Staff Nurse",
      image: "/alumni1.jpg",
      message: "RDS gave me the foundation I needed to excel in my career."
    },
    {
      name: "Rahul Verma",
      batch: "2021",
      company: "Cipla",
      position: "Production Officer",
      image: "/alumni2.jpg",
      message: "The practical training at RDS prepared me for industry challenges."
    },
    {
      name: "Neha Gupta",
      batch: "2023",
      company: "Max Healthcare",
      position: "Staff Nurse",
      image: "/alumni3.jpg",
      message: "Grateful to the placement cell for their constant support."
    }
  ];
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <nav className="flex text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-blue-600 font-semibold">Placement</span>
          </nav>
        </div>
        <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-3xl p-8 mb-8 text-white">
          <div className="flex items-center gap-4">
            <div className="bg-white/30 p-4 rounded-2xl">
              <FaBriefcase className="text-4xl" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">Placement Cell</h1>
              <p className="text-white/90 mt-2">Building Careers, Shaping Futures</p>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-4 text-center hover:shadow-xl transition-shadow">
              <div className={`text-${stat.color}-600 text-2xl mb-2 flex justify-center`}>
                {stat.icon}
              </div>
              <p className="text-2xl font-bold text-gray-800">{stat.value}</p>
              <p className="text-xs text-gray-500">{stat.label}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Placement Process</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {placementProcess.map((item, index) => (
                  <div key={index} className="flex gap-3">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center font-bold text-blue-600">
                      {item.step}
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-800">{item.title}</h3>
                      <p className="text-sm text-gray-600">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Top Recruiters & Packages</h2>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Company</th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Package</th>
                      <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">Positions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {topRecruiters.map((item, index) => (
                      <tr key={index} className="hover:bg-gray-50">
                        <td className="px-4 py-3 font-medium text-gray-800">{item.name}</td>
                        <td className="px-4 py-3 text-gray-600">{item.package}</td>
                        <td className="px-4 py-3 text-gray-600">{item.positions}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-6">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Alumni Testimonials</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {alumni.map((alum, index) => (
                  <div key={index} className="bg-gray-50 p-4 rounded-xl">
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-600 font-bold">
                        {alum.name.charAt(0)}
                      </div>
                      <div>
                        <p className="font-semibold text-gray-800">{alum.name}</p>
                        <p className="text-xs text-gray-500">Batch {alum.batch}</p>
                      </div>
                    </div>
                    <p className="text-sm text-gray-600 italic mb-2">"{alum.message}"</p>
                    <p className="text-xs text-blue-600">{alum.company} - {alum.position}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="lg:col-span-1 space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-6 sticky top-24">
              <h2 className="text-xl font-bold text-gray-800 mb-4">Our Recruiters</h2>
              
              <div className="space-y-4 max-h-[500px] overflow-y-auto pr-2">
                {recruiters.map((recruiter, index) => (
                  <div key={index} className="flex items-center gap-3 p-2 hover:bg-gray-50 rounded-lg transition-colors">
                    <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400">
                      <FaBuilding />
                    </div>
                    <div>
                      <p className="font-medium text-gray-800">{recruiter.name}</p>
                      <p className="text-xs text-gray-500 flex items-center gap-1">
                        <FaMapMarkerAlt className="text-xs" /> {recruiter.location}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-2xl p-6 text-white">
              <h3 className="text-lg font-bold mb-2">Placement Coordinator</h3>
              <p className="text-sm text-white/90 mb-4">For any placement-related queries</p>
              <div className="space-y-2 text-sm">
                <p>📞 <a href="tel:+917275370808" className="hover:underline">+917607094014</a></p>
                <p>✉️ <a href="mailto:placement@rdsnursing.edu" className="hover:underline">placement@rdsnursing.edu</a></p>
              </div>
              <button className="mt-4 bg-white text-blue-700 px-4 py-2 rounded-lg font-semibold text-sm hover:bg-blue-50">
                Register for Placement
              </button>
            </div>
          </div>
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-6 mb-8">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Placement Achievements</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-start gap-3">
              <FaTrophy className="text-yellow-500 text-2xl" />
              <div>
                <p className="font-semibold text-gray-800">Highest Package 2024</p>
                <p className="text-sm text-gray-600">8.5 LPA - Apollo Hospitals</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <FaUsers className="text-blue-600 text-2xl" />
              <div>
                <p className="font-semibold text-gray-800">International Placements</p>
                <p className="text-sm text-gray-600">UAE, UK, Australia</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <FaHandshake className="text-green-600 text-2xl" />
              <div>
                <p className="font-semibold text-gray-800">MoU with 50+ Hospitals</p>
                <p className="text-sm text-gray-600">Regular campus drives</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlacementPage;